<template>
  <div class="danmaku-component" :style="getAppearanceStyle">
    <danmaku ref="danmaku" v-model="danmus" v-bind="config">
      <template v-slot:dm="{ danmu }">
        <div class="danmu-item" :style="getTextStyle">
          {{ getContent(danmu.name) }}
        </div>
      </template>
    </danmaku>
  </div>
</template>

<script>
import danmaku from "./danmaku.vue"

export default {
  components: {
    danmaku
  },
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      danmus: [],
      config: {
        channels: this.options.rowLen, // 轨道数量，为0则弹幕轨道数会撑满容器
        useSlot: true, // 是否开启slot
        loop: true, // 是否开启弹幕循环
        speeds: this.options.speeds, // 弹幕速度，实际为每秒弹幕走过的像素距离
        fontSize: 20, // 文本模式下的字号
        right: 0, // 同一轨道弹幕的水平间距
        debounce: 100, // 弹幕刷新频率（多少毫秒插入一条弹幕，建议不小于50）
        randomChannel: true, // 随机轨道
        colorList: this.options.colorList // 背景色列表
      }
    }
  },
  watch: {
    "options.rowLen": {
      handler(val) {
        this.config.channels = val
      }
    },
    "options.speeds": {
      handler(val) {
        this.config.speeds = val
      }
    },
    "options.colorList": {
      handler(val) {
        this.config.colorList = val
      }
    },
    "options.danmuDatas": {
      handler(val) {
        this.danmus = val.filter(item => item.name)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgIsThemeColor || false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getAppearanceStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.bgStyle,
        opacity: this.options.opacity / 100,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        boxShadow: this.boxShadowStyle,
        padding: this.getPaddingStyle
      }
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.topPaddingTypeFlag || this.options.topPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px ${this.options.paddingRight}px ${this.options.paddingBottom}px ${this.options.paddingLeft}px`
      }
      return padding
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          // tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.options.boxShadowColor[index]}`
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getTextPaddingStyle() {
      let padding = `${this.options.textPadding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.textPaddingTop}px ${this.options.textPaddingRight}px ${this.options.textPaddingBottom}px ${this.options.textPaddingLeft}px`
      }
      return padding
    },
    textBoxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.textBoxShadowH)) {
        this.options.textBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
            `${this.options.textBoxShadowH[index]}px ${this.options.textBoxShadowV[index]}px ${this.options.textBoxShadowBlur[index]}px ${this.options.textBoxShadowSpread[index]}px ${this.$parseColor(this.options.textBoxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
          `${this.options.textBoxShadowH}px ${this.options.textBoxShadowV}px ${this.options.textBoxShadowBlur}px ${this.options.textBoxShadowSpread}px ${this.$parseColor(this.options.textBoxShadowColor)}`
      }
      return tmpStyle
    },
    getTextStyle() {
      let borderW = ""
      if (Array.isArray(this.options.textBorderWidth)) {
        this.options.textBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.textBorderWidth}px`
      }
      const lineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
          this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px"
      return {
        width: this.options.widthAuto ? "auto" : `${this.options.textWidth}px`,
        height: this.options.heightAuto ? "auto" : `${this.options.textHeight}px`,
        backgroundColor: "var(--background-color)",
        "font-style": this.options.fontStyle,
        "font-Family": this.options.fontFamily,
        // color: this.options.textIsThemeColor ? this.themeColor : this.options.color.color || this.options.color,
        color: this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        "font-size": `${this.options.fontSize}px`,
        "font-weight": this.options.fontWeight,
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent,
        "line-height": lineHeight,
        "text-align": this.options.textAlign,
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "border-top-left-radius": this.options.textBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.textBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.textBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.textBorderBottomLeftRadius + "px",
        "border-style": this.options.textBorderStyle,
        // "border-color": this.options.textBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.textBorderColor.color || this.options.textBorderColor,
        "border-color": this.$parseColor(this.options.textBorderColor, {
          isThemeColor: this.options.textBorderIsThemeColor
        }),
        "border-width": this.options.showTextBorder !== false ? borderW : 0,
        padding: this.getTextPaddingStyle,
        opacity: this.options.textOpacity / 100,
        "box-shadow": this.textBoxShadowStyle
      }
    }
  },
  methods: {
    getContent(value) {
      return this.options.textLimit ? value.substr(0, this.options.textLimitCount) : value
    }
  }
}
</script>

<style lang="scss" scoped>
.danmaku-component {
  height: 100%;
}
</style>
